import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import notCheckIcon from '../../assets/claims/empty-ellipsis.svg';
import checkMark from '../../assets/claims/check-circle-blue.svg';

import { CLAIM_STATUS_IDS } from '../../constants';

import './Stepper.css';

const CLAIM_PROGRESS_STATUS = {
  open: 0,
  records: 1,
  // eslint-disable-next-line sort-keys
  inReview: 2,
  // eslint-disable-next-line sort-keys
  done: 3,
};

const CircleStep = ({ icon, isComplete = false, stepValue = '' }) => (
  <div className="Circle-status">
    <img alt="" src={icon} />

    <span className="Circle-number" data-completed={isComplete}>
      {stepValue}
    </span>
  </div>
);

const Stepper = ({ statusId }) => {
  const { t } = useTranslation('claims');

  const inRecordsComplete = [
    CLAIM_STATUS_IDS.records,
    CLAIM_STATUS_IDS.inReview,
    CLAIM_STATUS_IDS.done,
  ].includes(statusId);
  const inReviewComplete = CLAIM_STATUS_IDS.inReview === statusId;
  const inDoneComplete = CLAIM_STATUS_IDS.done === statusId;

  const currentStyleProgress = useMemo(() => {
    switch (statusId) {
      case CLAIM_STATUS_IDS.records:
        return 'records';

      case CLAIM_STATUS_IDS.inReview:
        return 'in-review';

      case CLAIM_STATUS_IDS.done:
        return 'done';

      case CLAIM_STATUS_IDS.open:
      default:
        return 'open';
    }
  }, [statusId]);

  return (
    <div className="Stepper-main-container">
      <div className="Status-row-text-container">
        <span>{t('statusOpen')}</span>

        <span>{t('statusRecords')}</span>

        <span>{t('statusInReview')}</span>

        <span>{t('statusDone')}</span>
      </div>

      <div className="Circle-row-container">
        <div className="Line-status-background" />

        <div
          className={'Line-status-percentage Line-status-'
            + `${currentStyleProgress}`}
        />

        <CircleStep icon={checkMark} isComplete />

        <CircleStep
          icon={inRecordsComplete ? checkMark : notCheckIcon}
          isComplete={inRecordsComplete}
          stepValue={CLAIM_PROGRESS_STATUS.records}
        />

        <CircleStep
          icon={inReviewComplete || inDoneComplete ? checkMark : notCheckIcon}
          isComplete={inReviewComplete || inDoneComplete}
          stepValue={CLAIM_PROGRESS_STATUS.inReview}
        />

        <CircleStep
          icon={inDoneComplete ? checkMark : notCheckIcon}
          isComplete={inDoneComplete}
          stepValue={CLAIM_PROGRESS_STATUS.done}
        />
      </div>
    </div>
  );
};

export { Stepper };
